import { ref, watch, computed } from '@vue/composition-api'
// import store from '@/store'
import store from '@/store/index.js'

// Notification
// import { useToast } from 'vue-toastification/composition'
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useMattersList({ type = 'all', query = null }) {
  // Use toast
  // const toast = useToast()

  const refInvoiceListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'type', label: 'Notifications', sortable: false },
  ]
  const perPage = ref(10)
  const totalInvoices = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const statusFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refInvoiceListTable.value
      ? refInvoiceListTable.value.localItems.length
      : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalInvoices.value,
    }
  })

  const refetchData = () => {
    refInvoiceListTable.value.refresh()
  }

  watch([currentPage, perPage, statusFilter], () => {
    refetchData()
  })

  const fetchInvoices = (ctx, callback) => {
    console.log({ MType: query })

    let queryParams = {}
    if (type != 'all') {
      queryParams = {
        perPage: perPage.value,
        page: currentPage.value,
        ntype: type,
      }
    } else {
      queryParams = {
        perPage: perPage.value,
        page: currentPage.value,
      }
    }

    store
      .dispatch('notificationStore/fetchNotifications', { ctx: this, queryParams })
      .then(response => {
        console.log({ Notifications: response })
        callback(response.data)
        totalInvoices.value = response.meta.total
      })
      .catch(e => {
        console.log(e)
      })
  }

  return {
    fetchInvoices,
    tableColumns,
    perPage,
    currentPage,
    totalInvoices,
    dataMeta,
    perPageOptions,
    sortBy,
    isSortDirDesc,
    refInvoiceListTable,

    statusFilter,

    refetchData,
  }
}
